import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileText, Shield } from "lucide-react";
import ViewDocument from "../Pages/ViewDocument";
import { useLanguage } from '../StoreContext/LanguageContext';

export default function ViewDocumentPublic() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ allTotalCount: 0, totalCount: 0 });
    const [activeFilters, setActiveFilters] = useState({}); 
  const { language, translations } = useLanguage();

  const buildFilterString = () => {
  const parts = [];
  if (activeFilters.district) parts.push(`जिल्हा: ${activeFilters.district}`);
  if (activeFilters.taluka)   parts.push(`तालुका: ${activeFilters.taluka}`);
  if (activeFilters.village)  parts.push(`गाव: ${activeFilters.village}`);
  if (activeFilters.category) parts.push(`वर्ग: ${activeFilters.category}`);
  if (activeFilters.project)  parts.push(`प्रकल्प: ${activeFilters.project}`);
  if (activeFilters.laqOffice) parts.push(`कार्यालय: ${activeFilters.laqOffice}`);
  return parts.join(", ");
};

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">

      {/* Top Bar */}
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white shadow-lg sticky top-0 z-50">
        {/* <div className="mx-auto px-4 py-3 flex items-center justify-between gap-4"> */}
        <div className="mx-auto px-4 py-3 flex items-center gap-4">

          {/* Left: Back + Title */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-3 py-2 rounded-lg text-sm font-medium transition"
            >
              <ArrowLeft size={16} />
              Back
            </button>

            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center">
                <FileText size={18} className="text-blue-200" />
              </div>
              <div>
                <h1 className="text-base md:text-lg font-semibold leading-tight">
                  {translations[language]?.completedPortel}
                </h1>
                <p className="text-xs text-blue-300 leading-tight">
                  Land Acquisition &amp; Project Documents
                </p>
              </div>
            </div>

          </div>

          {/* Right: Stats badges */}
          <div className="flex items-center gap-3">
            <div style={{
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.3)",
              borderRadius: 8,
              padding: "4px 14px",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.9)", fontWeight: 700 }}>
                अंतिम निवाडा
              </span>
              <span style={{ color: "rgba(255,255,255,0.4)", fontSize: 16 }}>|</span>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", fontWeight: 500 }}>एकूण प्रकरण</span>
              <span style={{ fontSize: 20, fontWeight: 800, color: "#fff", lineHeight: 1 }}>
                {stats.allTotalCount > 0 ? stats.allTotalCount.toLocaleString() : "—"}
              </span>
              <span style={{ color: "rgba(255,255,255,0.4)", fontSize: 16 }}>|</span>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", fontWeight: 500 }}>एकूण अंतिम निवाडा साठी  {buildFilterString()} </span>
              <span style={{ fontSize: 20, fontWeight: 800, color: "#fff", lineHeight: 1 }}>
                {stats.totalCount > 0 ? stats.totalCount.toLocaleString() : "—"}
              </span>
            </div>
          </div>

        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col m-5 bg-slate-50 shadow-sm">
        <ViewDocument mode="public" onStatsChange={setStats}   onFiltersChange={setActiveFilters} />
      </div>

    </div>
  );
}